import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-event',
    templateUrl: './editor-eligibility-rule-form-has-event.component.html',
    styleUrls: ['./editor-eligibility-rule-form-has-event.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasEventComponent implements OnInit {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  eventTypeGroupNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.eventTypeGroupNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        eventTypeGroupNames => {
          this.eventTypeGroupNames = eventTypeGroupNames;
        }
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getBlueprintsFormArray(): FormArray {
    return this.formGroup.get('blueprints') as FormArray;
  }
}
